import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';

import { requiredWhenPresent } from '../../shared/propTypes';
import { PeriodPropTypes } from '../../shared/propTypes/period';
import { TaxBookingEntityPropTypes } from '../../shared/propTypes/taxBookingEntities';

const DeleteTaxBookingEntityModal = ({
  period,
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
  isRemovingInProgress,
}) => {
  const removeTaxBooking = useCallback(() => {
    removeEntity({ ...entityToRemove, periodName: period.name }, { rowIndex });
  }, [removeEntity, entityToRemove, period, rowIndex]);

  return (
    <Modal
      className="delete-tax-booking-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Tax Booking"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeTaxBooking}
      isVisible={isVisible}
      isSubmitting={isRemovingInProgress}
    >
      { entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/><br/>
            Company Code: {entityToRemove.companyCode}<br/>
            Legal Entity: {entityToRemove.legalEntity}<br/>
            TBE Legal Entity: {entityToRemove.tbeLegalEntity}<br/>
            TBE Type: {entityToRemove.tbeType}<br/>
            Period: {period.name}<br/><br/>
          </div>
        )
        : null
      }
    </Modal>
  );
};

DeleteTaxBookingEntityModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  period: PeriodPropTypes.isRequired,
  entityToRemove: requiredWhenPresent(['isVisible'], TaxBookingEntityPropTypes),
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
  isRemovingInProgress: PropTypes.bool.isRequired,
};

export default DeleteTaxBookingEntityModal;
